module.exports = "mutation ($id: ID!) {\n  TaskDelete(id: $id) {\n    id\n  }\n}\n"